import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-service-cards',
  templateUrl: './three-service-cards.component.html',
  styleUrls: ['./three-service-cards.component.css']
})
export class ThreeServiceCardsComponent implements OnInit {

  constructor() { }

  @Input()
  titles: string[];

  @Input()
  texts: string[];

  @Input()
  icons: string[];

  ngOnInit(): void { }

}
